import { openMiniCart } from "../components/miniCart";

export function productAdded(product) {
  let productAdded = document.querySelector(".product-added"),
    img = productAdded.querySelector("img"),
    title = productAdded.querySelector(".product-added__product-name"),
    viewCart = productAdded.querySelector(".product-added__button");

  viewCart.addEventListener("click", () => {
    openMiniCart();
  });

  productAdded.classList.add("added");

  let productTitle =
    product.querySelector(".product-article__title")?.textContent ||
    product.querySelector(".product-data__title")?.textContent;

  if (productTitle) {
    title.textContent = productTitle;
  }

  let productImage = product.querySelector("img");
  if (productImage) {
    img.src = productImage.src;
  }

  setTimeout(() => {
    productAdded.classList.remove("added");
  }, 3000);
}
